// Copyright (c) Docugami, Inc. All rights reserved.

export enum InteractEvent {
    Resize = 'Resize',
    Link = 'Link',
    DragStart = 'DragStart',
    DragEnd = 'DragEnd'
}
